import React, {useState, useContext, useEffect} from 'react';
import { Grid } from '@material-ui/core';
import SearchableTable from '../components/SearchableTableV2';
import Content from '../components/Content';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../contexts';

const options = [
	'Create',
	'Back'
  ];
  
const ITEM_HEIGHT = 48;

const useStyles = makeStyles((theme) => ({
	root: {
	  width: '100%',
	},
	heading: {
	  fontSize: theme.typography.pxToRem(15),
	  fontWeight: theme.typography.fontWeightRegular,
	},
  }));

const AssetsDetails = () => {
	const context = useContext(UserContext);

	const classes = useStyles();
	const history = useHistory();

	const [rowsToPush, setRowsToPush] = useState([]);
	const [selectedRawEdit, setSelectedRawEdit] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);

  	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		console.log(e.target.textContent);
		switch(e.target.textContent){
			case 'Create':
				if(context.userInfo.role === 'Admin')
					history.push({pathname: '/assets/create'});
				else
					alert('Sorry, you are not allowed to create an Asset Item');
				break;
			case 'Back':
				history.goBack();
				break;
			default:
		}
		
		setAnchorEl(null);
	};

	useEffect(() => {
		return () => {
		
		}
	}, [])
	
	
	return (
		<Content>
			<div>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleClick}
				>
					<MoreVertIcon />
				</IconButton>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
				
				>
					<span>Assets Details</span>
				</IconButton>
				
				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 5,
						width: '20ch',
					},
					}}
				>
					{options.map((option) => (
					<MenuItem key={option} selected={option === 'Pyxis'} onClick={(e)=>handleClose(e)}>
						{option}
					</MenuItem>
					))}
				</Menu>
			</div>

			<Grid item xs={12} md={12}>
				<SearchableTable
				    
					table = {'masterlist'}
					
					defaultSortColumn = "id_master"

					keyIdentifier = "idMaster"

					filterTable = ""
					
					filters = { true }
					
					filterQuery
					
					enableFormEdit = { true }
				
					enableRawEdit = { false }

					selectedRawEdit = { [selectedRawEdit] }

					enableSelect = { false }

					useDataRowsFromParent = { false }
					
					queryId="assetDetailsQuery"

					displayedHeaders={[
						{
							key: 'assetTag',
							displayedHeader: 'Asset Tag',
							displayedLength: 20,
							withList: false,
							
						},
						{
							key: 'assetDesc',
							displayedHeader: 'Asset Description',
							displayedLength: 50,
							withList: false,
						},
						{
							key: 'serialNo',
							displayedHeader: 'Serial Number',
							displayedLength: 50,
							withList: false
						},
						{
							key: 'maximoId',
							displayedHeader: 'Maximo ID',
							displayedLength: 50,
							withList: false
						}
						
					]}

					displayRows = {[
						{
							key: 'idMaster',
							displayedHeader: 'ID',
							type: 'id',
						},
						{
							key: 'assetTag',
							displayedHeader: 'Asset Tag',
							displayedLength: 50,
						},
						{
							key: 'assetDesc',
							displayedHeader: 'Asset Description',
							displayedLength: 50,
						},
						{
							key: 'serialNo',
							displayedHeader: 'Serial Number',
							displayedLength: 50,
						},
						{
							key: 'maximoId',
							displayedHeader: 'Maximo ID',
							displayedLength: 50,
						}
					]}
				/>
			</Grid>
			
			
		</Content>
	);
};

export default AssetsDetails;
